import styled from 'styled-components'

const ModalContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  gap: 8px;
`

export default ModalContentContainer
